import LinearProgress from "@mui/material/LinearProgress";
import React from "react";

export function QLoadingProgressBars(props) {

    return (
        <div>
            {props.numLines === 1 ?
                <LinearProgress color="secondaryNew"/>
                :
                <React.Fragment>
                    <LinearProgress color="secondaryNew"/>
                </React.Fragment>
            }
        </div>
    )
}
